import { render, staticRenderFns } from "./BasePalette.vue?vue&type=template&id=0d3f2a36&scoped=true&"
import script from "./BasePalette.vue?vue&type=script&lang=js&"
export * from "./BasePalette.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=0d3f2a36&prod&scoped=true&lang=css&"
import style1 from "./BasePalette.vue?vue&type=style&index=1&id=0d3f2a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3f2a36",
  null
  
)

export default component.exports